import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { MQRequest } from "@eres/mortgageQuotationAPI/entities";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import Strings from "@my-dld/assets/strings";
import MQRequestsListView from "../../../components/MyRequest/MQRequestsListView";
import { getRequests } from "@eres/mortgageQuotationAPI/api";
import { getParticipantID } from "@10x/sso";
import { hideLoading, showErrorMessage } from "@my-dld/utils/UIUtils";
import { CurrencyUtil } from "@eres/core";
import I8N from "@eres/core/dist/I8N";
import { getLandNumberByTitle, getUnitNumberByTitle, getVillaNameByTitle, TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { convertToSqMt, UnitSystem } from "@my-dld/utils/UnitUtils";
import MQRequestsGridView from "../../../components/MyRequest/MQRequestsGridView";
import { formatAppDate } from "@my-dld/utils/Utils";
import { getAppServices } from "@10x/coreapp";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	landRequests: MQRequest[];
	villaRequests: MQRequest[];
	unitRequests: MQRequest[];
	unit: UnitSystem;
}

class MQRequests extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			landRequests: [],
			villaRequests: [],
			unitRequests: [],
			unit: getAppServices().storeService.getStore().getState().User.unit,
		};
	}

	componentDidMount() {
		this.loadMQRequests();
	}

	render() {
		const { isLoading, landRequests, villaRequests, unitRequests } = this.state;
		const isDataFound = landRequests.length > 0 || villaRequests.length > 0 || unitRequests.length > 0;
		return <ListGridDataView
			isLoading={ isLoading }
			dataAvailable={ isDataFound }
			title={ Strings.mortgage_quotation }
			onUnitSystemChange={ this.onUnitChange }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }/>;
	}

	private onUnitChange = ( unit: UnitSystem ) => {
		this.setState( { unit: unit } );
	};

	private renderListView = () => {
		const { landRequests, villaRequests, unitRequests, unit } = this.state;
		return <>
			{ landRequests && landRequests.length > 0 && <MQRequestsListView
				type={ TabuPropertyType.LAND }
				items={ landRequests }
				unit={ unit }/> }
			{ villaRequests && villaRequests.length > 0 && <MQRequestsListView
				type={ TabuPropertyType.VILLA }
				items={ villaRequests }
				unit={ unit }/> }
			{ unitRequests && unitRequests.length > 0 && <MQRequestsListView
				type={ TabuPropertyType.UNIT }
				items={ unitRequests }
				unit={ unit }/> }
		</>;
	};

	private renderGridView = () => {
		const { landRequests, villaRequests, unitRequests, unit } = this.state;
		return <>
			{ landRequests && landRequests.length > 0 && <div className="land">
				<MQRequestsGridView
					type={ TabuPropertyType.LAND }
					items={ landRequests }
					unit={ unit }/>
			</div> }
			{ villaRequests && villaRequests.length > 0 && <div className="villa">
				<MQRequestsGridView
					type={ TabuPropertyType.VILLA }
					items={ villaRequests }
					unit={ unit }/>
			</div> }
			{ unitRequests && unitRequests.length > 0 && <div className="unit">
				<MQRequestsGridView
					type={ TabuPropertyType.UNIT }
					items={ unitRequests }
					unit={ unit }/></div> }
		</>;
	};

	private loadMQRequests() {
		getRequests( getParticipantID()! ).then( ( response: MQRequest[] ) => {
			const lands = response.filter( x => x.property.propertyType === TabuPropertyType.LAND );
			const villas = response.filter( x => x.property.propertyType === TabuPropertyType.VILLA ||
				x.property.propertyType === TabuPropertyType.BUILDING );
			const units = response.filter( x => x.property.propertyType === TabuPropertyType.UNIT );
			hideLoading();
			this.setState( {
				isLoading: false,
				landRequests: lands,
				villaRequests: villas,
				unitRequests: units,
			} );
		} ).catch( e => {
			this.setState( { isLoading: false } );
			hideLoading();
			showErrorMessage( e );
		} );
	}
}

export function getMQLandNo( item: MQRequest ) {
	return getLandNumberByTitle( item.property.title );
}

export function getMQVillaName( item: MQRequest ) {
	return getVillaNameByTitle( item.property.title );
}

export function getMQUnitNo( item: MQRequest ) {
	return getUnitNumberByTitle( item.property.title );
}

export function getMQArea( item: MQRequest ) {
	return I8N.isRTL() ? item.property.areaNameAr : item.property.areaNameEn;
}

export function getMQSize( item: MQRequest, isSqFt: boolean ) {
	return "" + ( isSqFt ? item.property.propertySize : convertToSqMt( Number( item.property.propertySize ) ) );
}

export function getMQReqDate( item: MQRequest ) {
	const date = item.createdDate.asDate();
	return formatAppDate( date, "en" );
}

export function getMQRefNo( item: MQRequest ) {
	return item.mortgageRequestReference;
}

export function getMQAmount( item: MQRequest ) {
	let val: string | number | null = item.mortgageValue;
	if ( val == null || val <= 0 )
		val = "";
	else
		val = CurrencyUtil.toFormattedCurrency( val );
	return val;
}

export function getMQTenure( item: MQRequest ) {
	const years = item.numberOfYears;
	return `${ years } ${ years > 1 ? Strings.years : Strings.year }`;
}

export function getMQBank( item: MQRequest ) {
	return I8N.isRTL() ? item.selectedBank.nameAr : item.selectedBank.nameEn;
}

export default MQRequests;
